import instance from '../scorpiusInstance';
import {
  CREATE_APP_CIDR_START,
  CREATE_APP_CIDR_SUCCESS,
  CREATE_APP_CIDR_ERROR,
} from '../types';

export const createAppCIDRStart = (orgId, appName) => ({
  type: CREATE_APP_CIDR_START,
  orgId,
  appName,
});

export const createAppCIDRSuccess = (orgId, appName, cidr) => ({
  type: CREATE_APP_CIDR_SUCCESS,
  orgId,
  appName,
  cidr,
});

export const createAppCIDRError = (orgId, appName, error) => ({
  type: CREATE_APP_CIDR_ERROR,
  orgId,
  appName,
  error,
});

/**
 * Create a CIDR record for an organization
 * @param {String} orgId - The organization's ID
 * @param {String} appName
 * @param {Object} cidr - CIDR record
 * @param {Number} cidr.id - id of the CIDR address record
 * @param {String} cidr.cidr - IP address
 * @param {Boolean} cidr.enabled - Enabled state for the IP address
 */
export const createAppCIDR = (orgId, appName, cidr) => async dispatch => {
  dispatch(createAppCIDRStart(orgId, appName));
  try {
    const response = await instance.post(
      `/organizations/${orgId}/cidrs`,
      cidr,
      { headers: { retry: true } },
    );
    return dispatch(createAppCIDRSuccess(orgId, appName, response.data));
  } catch (error) {
    throw dispatch(createAppCIDRError(orgId, appName, error));
  }
};

export default createAppCIDR;
